// DownloadButton.js
import React from 'react'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

const DownloadButton = ({ targetRef }) => {
  const downloadPDF = async () => {
    const element = targetRef.current
    const canvas = await html2canvas(element, { scale: 2 })
    const imgData = canvas.toDataURL('image/png')
    const pdf = new jsPDF('l', 'mm', 'a4')
    const imgWidth = 297 // 297  210
    const imgHeight = (canvas.height * imgWidth) / canvas.width
    let heightLeft = imgHeight
    let position = 0

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    heightLeft -= 210 // Высота A4 в мм (горизонтально)

    while (heightLeft > 0) {
      position -= 210
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
      heightLeft -= 210
    }
    pdf.save('protocol.pdf')
  }

  return (
    <button
      onClick={downloadPDF}
      style={{ marginTop: '20px', padding: '10px 15px' }}
    >
      Скачать PDF
    </button>
  )
}

export default DownloadButton
